import React from 'react';
import {OffersSection} from '../../offers-section';
import {StyledLandingWrapper} from './styled';

export const AllOffers = () => (
  <StyledLandingWrapper>
    <OffersSection />
  </StyledLandingWrapper>
);
